import { showNotification } from '@mantine/notifications';
import Axios from 'axios';
import { ToastIconComponent } from '@/components';
import { XORIGIN, XVERSION } from '@/config';
import { PAYTM_APP } from '@/constants/default';
import { logout } from '@/services/auth';
import { getDeviceId } from '@/utils/device';
import storage from '@/utils/storage';

export const getAuthHeader = async () => {
  try {
    const webAccessToken = storage.getItem('webAccessToken');
    return webAccessToken ? `Bearer ${webAccessToken}` : undefined;
  } catch (error) {
    return undefined;
  }
};

export const getAuthSkippedCompanyId = async () => {
  try {
    const webAccessToken = storage.getItem('webAccessToken');
    const company = storage.getItem('company');
    return !webAccessToken ? company?.id : null;
  } catch (error) {
    return undefined;
  }
};

export const getCompanyId = async () => {
  try {
    const company = storage.getItem('company');
    return company?.id;
  } catch (error) {
    return undefined;
  }
};

export const getUserDeviceId = async () => {
  try {
    const webAccessToken = storage.getItem('webAccessToken');
    const deviceId = await getDeviceId();
    return !webAccessToken ? deviceId : null;
  } catch (error) {
    return null;
  }
};

export const getXOrigin = async () => {
  try {
    const miniPwa = storage.getItem('miniPwa');
    const xOrigin = storage.getItem('xOrigin');

    if (xOrigin === PAYTM_APP) {
      return PAYTM_APP;
    }
    if (miniPwa && xOrigin) {
      return xOrigin;
    }
    return XORIGIN;
  } catch (error) {
    return null;
  }
};

export const authRequestInterceptor = async (req: any) => ({
  ...req,
  headers: {
    ...req.headers,
    'Content-Type': 'application/json',
    Authorization: await getAuthHeader(),
    currentcompanyid: await getAuthSkippedCompanyId(),
    company_id: await getCompanyId(),
    DeviceId: await getUserDeviceId(),
    'x-origin': await getXOrigin(),
    'x-version': XVERSION,
  },
  // withCredentials: true,
});

export const axios = Axios.create({
  baseURL: '/api/',
  // baseURL: 'https://rest.rc.hungerbox.com/api/',
});

axios.interceptors.request.use(authRequestInterceptor);
axios.interceptors.response.use(
  (response) => response.data,
  async (error) => {
    const message = error.response?.data?.message || error.message;
    if (message && error.response?.status === 401) {
      showNotification({
        message,
        icon: ToastIconComponent(),
      });
      logout();
    }
    if (message && error.response?.status === 503) {
      showNotification({
        message,
        icon: ToastIconComponent(),
      });
    }

    return await Promise.reject(error);
  }
);
